<template>
  <div id="scroll">
    <div class="container">
        <el-form ref="ruleForm" :model="ruleForm" label-width="80px">
        <el-form-item label="所属类别">
          <el-select v-model="ruleForm.type" placeholder="请选择所属类别">
            <el-option
              v-for="item in list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="editWrap">

        <editor-vue
          class="editor"
          :value="ruleForm.text"
          @input="(res) => (ruleForm.text = res)"
        >
        </editor-vue>
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addNew()">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addCompanyIntro,editCompnayIntro} from "@/api/manage";
import editorVue from "@/components/txtModule/richText.vue";
export default {
  data() {
    return {
      ruleForm: {
        text: "",
        type:''
      },
      val: "",
      isEdit: false,
      editId: "",
      list:[{id:1,name:'公司简介'},{id:2,name:'企业文化'},{id:3,name:'荣誉资质'}]
    };
  },
  components: {
    editorVue,
  },
  created() {
    this.isEdit = this.$route.params.typeOf == "edit";
    this.editId = this.$route.params.id||'';
    this.ruleForm.text=this.$route.params.text?decodeURI(this.$route.params.text):''
    this.ruleForm.type=this.$route.params.type||''
  },
  methods: {
    async addNew() {
      //确认新增
        if (!this.isEdit) {  //新增
          if ( this.ruleForm.text.length == 0) {
           return this.$message.error('内容不能为空！')
          }else if(this.ruleForm.type==''){
            return this.$message.error('请选择所属类别！')
          }
            //必填项不能为空，否则不能上传
            this.ruleForm.text=encodeURI(this.ruleForm.text+'')
            let res = await addCompanyIntro(this.ruleForm);
            if (res.code == 200) {
                this.$message.success("添加成功！");
              this.ruleForm.text=''
              this.ruleForm.type=''
              this.$router.replace("/aboutUs");
            }
        } else {//编辑状态
          let param = {};
          param.id = this.editId
          param.text = encodeURI(this.ruleForm.text+'')
          param.type=this.ruleForm.type
          let res = await editCompnayIntro(param);
          if(res.code==200){
            this.$message.success('编辑成功！')
            this.$router.replace("/aboutUs");
          }
        }
    },
    cancel() {
      this.$router.replace("/aboutUs");
    },
  },
};
</script>

<style lang="less" scoped>
#scroll {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.el-form {
  display: flex;
  flex-wrap: wrap;
}
.el-form .el-input {
  width: 215px;
}
</style>